import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-item-move-report',
  templateUrl: './sub-item-move-report.component.html',
  styleUrls: ['./sub-item-move-report.component.css']
})
export class SubItemMoveReportComponent implements OnInit {

  public menu_item_id = '34';

  search_obj = {
    'placeholder': 'اسم/ رقم الصنف', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': ' AND `main_item`.`main_item_id` = `sub_item`.`main_item_id`'
    }]
  };

  private dp = [];
  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  branches = [];
  branchList = [];
  allStoreList = [];
  storeList = [];

  displayedColumns = ['sub_item_number', 'main_item_name', 'count', 'current_count', 'detail', 
    'invoice_no', 'partner', 'invoice_date', 'name', 'created_on'];  // 'main_item_name', 'sub_item_no', 'unit_name',

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  view_type = [{ 'view_value': 'sub_item', 'view_name': 'الصنف', 'view_name_en': 'Item' },
  { 'view_value': 'item_cat', 'view_name': 'التصنيف', 'view_name_en': 'Item Category' }];

  model = {
    'branch_id': '0', 'from_date': new Date(), 'to_date': new Date(), 'title': 'تقرير حركة الصنف',
    'view_type': 'sub_item', 'item_cat_id': '', 'item_subcat_id': '', 'sub_item_no': '', 'store_id': '0'
  };

  Sub_Item_Move_Rep; Sales; Sales_Return; Stock; Production;
  Sub_item_Placeholder; From_Date; To_Date;
  From_Date_Msg; To_Date_Msg; Branch_Msg; Store_Msg;
  Sub_Item_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_Item_Move_Rep').subscribe((res: string) => {
      this.Sub_Item_Move_Rep = res;
    });
    this.model['title'] = this.Sub_Item_Move_Rep;

    translate.get('Sales').subscribe((res: string) => {
      this.Sales = res;
    });

    translate.get('Sales_Return').subscribe((res: string) => {
      this.Sales_Return = res;
    });

    translate.get('Stock').subscribe((res: string) => {
      this.Stock = res;
    });

    translate.get('Production').subscribe((res: string) => {
      this.Production = res;
    });

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    });
    
    translate.get('Sub_Item_Msg').subscribe((res: string) => {
      this.Sub_Item_Msg = res;
    });
  }

  ngOnInit() {
    let query, obj;

    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'اختر', 'branch_name_en': 'Select' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'اختر', 'store_name_en': 'Select' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  onChangeSearch = function (search_result: object) {
    if (search_result['no'] != '') {
      this.model['sub_item_no'] = search_result['no'];
    }
  }

  search() {
    this.dp = [];

    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    if (this.model['sub_item_no'] == '') {
      alert(this.Sub_Item_Msg);
      return false;
    }

    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      return false;
    }

    if (this.model['store_id'] == '0') {
      alert(this.Store_Msg);
      return false;
    }

    let from_date, to_date;
    if (this.model['from_date'] != undefined) {
      from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";
    }

    if (this.model['to_date'] != undefined) {
      to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + " 23:59:59";
    }

    // cmd = getSubItemMove, input: from date, to date, sub itme no, store id
    let obj = { cmd: 'getSubItemMove', from_date: from_date, to_date: to_date, 
      sub_item_no: this.model['sub_item_no'], store_id: this.model['store_id'] };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
      
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' +
      this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
